module.exports = __webpack_public_path__ + "img/IMG_0186.a9e82b35.jpg";